import React from "react";

export type TabInfo = {
  tabName: string;
  label: string;
  onclick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

type TabProps = {
  tabs: TabInfo[];
  activeTab: string;
};

const Tabs: React.FC<TabProps> = ({ tabs, activeTab }) => {
  return (
    <>
      {tabs.map((t, id) => (
        <button
          id={t.tabName}
          className={t.tabName === activeTab ? "Tab Active" : "Tab"}
          onClick={t.onclick}
          key={id}
        >
          {t.label}
        </button>
      ))}
    </>
  );
};

export default Tabs;
